/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Controllers.FriendLandingPage = class FriendLandingPage {
  constructor(el) {
    this._updateButton = this._updateButton.bind(this);
    this._requestSuccess = this._requestSuccess.bind(this);
    this._requestSuccessWithSingleStep = this._requestSuccessWithSingleStep.bind(this);
    this._requestSuccessWithPostPurchaseTracking = this._requestSuccessWithPostPurchaseTracking.bind(this);
    this._step1Complete = this._step1Complete.bind(this);
    this._step2Complete = this._step2Complete.bind(this);
    this._requestFailed = this._requestFailed.bind(this);
    this._allFieldsValid = this._allFieldsValid.bind(this);
    this.el = el;
    this.pb = new Buyapowa.Helpers.ProgressButton(this.el.find('button[data-button]'));
    this.view = new Buyapowa.Views.FriendLandingPage(this.el, this);

    this.view.toggleTick();
    this.view.onFieldChange(this._updateButton);

    if (this.view.shouldAutoSubmit()) {
      if (this.view.revealVoucher) {
        this.revealVoucher(true);
      } else {
        this.revealContinueButton();
      }
    }
  }

  disable(buttonText) {
    this.originalText = this.view.setButtonText(buttonText);
    this.view.disableButton();
    return this.view.disableInputs();
  }

  enable() {
    this.view.setButtonText(this.originalText);
    this._updateButton();
    return this.view.enableInputs();
  }

  revealContinueButton() {
    return $.ajax({
      method: 'post',
      url: this.view.getUrl(),
      data: this.view.getData()
    }).done(this._requestSuccess).fail(this._requestFailed);
  }

  revealVoucher(auto) {
    if (auto == null) { auto = false; }
    this.pb.started(this.view.codeProgressText());

    const fn = () => {
      return $.ajax({
        method: 'post',
        url: this.view.getUrl(),
        data: this.view.getData()
      }).done(this._requestSuccess).fail(this._requestFailed);
    };

    if (auto) {
      return setTimeout(fn, 1500);
    } else {
      return fn();
    }
  }

  _updateButton() {
    if (this._allFieldsValid()) {
      this.view.enableButton();
    } else {
      this.view.disableButton();
    }

    return this.view.toggleTick();
  }

  onSuccess(cb) {
    return this.cb = cb;
  }

  _requestSuccess(voucherResult) {
    if (this.cb != null) {
      this.cb(voucherResult);
      return;
    }
    if (this.view.postPurchaseTrackingEnabled()) {
      return this._requestSuccessWithPostPurchaseTracking();
    } else {
      return this._requestSuccessWithSingleStep(voucherResult);
    }
  }

  _requestSuccessWithSingleStep(voucherResult) {
    if (!this.view.autoSubmitButton) {
      this.pb.finished(true, this.view.doneText());
    }

    this.view.disableInputs();
    if (this.view.autoContinueToFriendConfirmationPage) {
      return this.view.redirectToFriendConfirmationPage();
    } else if (this.view.autoContinueToFriendConfirmationPageWithVoucher && voucherResult.successful) {
      return this.view.redirectToFriendConfirmationPage();
    } else if (this.view.autoContinueToClientSite && voucherResult.successful) {
      return this.view.redirectToClientSite();
    } else {
      return this.view.showResult(voucherResult);
    }
  }

  _requestSuccessWithPostPurchaseTracking() {
    if (this._step1Complete()) {
      this.view.disableInputs();
      this.view.disableButton();
      this.view.enableCustomField();
      this.pb.finished(false, this.view.almostDoneText());
      return this.view.showPostPurchaseTrackingInstructions();
    } else if (this._step2Complete()) {
      return this.view.redirectToFriendConfirmationPage();
    }
  }

  _step1Complete() {
    return this._allFieldsValid() && !this.view.displayCustomFieldTick();
  }

  _step2Complete() {
    return this.view.displayCustomFieldTick();
  }

  _requestFailed() {
    return this.pb.finished(false, this.view.failureText());
  }

  _allFieldsValid() {
    const fields = ['email', 'fullName', 'firstName', 'lastName', 'termsOptIn', 'marketingOptIn', 'customField'];
    for (var i of Array.from(fields)) {
      if (!this.view[`${i}Valid`]()) { return false; }
    }

    return true;
  }
};
